var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGlassWine = function SvgGlassWine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.22222 2.25C4.13299 2.25 3.25 3.133 3.25 4.22223L3.25 6C3.25 10.5798 6.76847 14.3378 11.2498 14.7183L11.2498 20.25L7.99976 20.25C7.58555 20.25 7.24976 20.5858 7.24976 21C7.24976 21.4142 7.58555 21.75 7.99976 21.75L11.9998 21.75L15.9998 21.75C16.414 21.75 16.7498 21.4142 16.7498 21C16.7498 20.5858 16.414 20.25 15.9998 20.25L12.7498 20.25L12.7498 14.7183C17.2313 14.338 20.75 10.5799 20.75 6L20.75 4.22223C20.75 3.133 19.867 2.25 18.7778 2.25L5.22222 2.25ZM4.75 4.22223C4.75 3.96142 4.96142 3.75 5.22222 3.75L18.7778 3.75C19.0386 3.75 19.25 3.96142 19.25 4.22223L19.25 6C19.25 10.0041 16.0041 13.25 12 13.25C7.99594 13.25 4.75 10.0041 4.75 6L4.75 4.22223Z"
  })));
};
export default SvgGlassWine;